import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Collapse,
  IconButton
} from "@mui/material";
import { supabase } from "../lib/supabase";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function groupBy(arr, key) {
  return arr.reduce((acc, item) => {
    const group = item[key];
    if (!group) return acc;
    if (!acc[group]) acc[group] = [];
    acc[group].push(item);
    return acc;
  }, {});
}

function Installments() {
  const [installments, setInstallments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openRows, setOpenRows] = useState({});

  useEffect(() => {
    const fetchInstallments = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from("transactions")
        .select("*")
        .neq("installment_group_id", null)
        .order("installment_group_id", { ascending: false })
        .order("installment_number", { ascending: true });

      if (error) {
        setInstallments([]);
        setLoading(false);
        return;
      }

      const grouped = groupBy(data, "installment_group_id");
      setInstallments(Object.values(grouped));
      setLoading(false);
    };

    fetchInstallments();
  }, []);

  const handleToggleRow = (groupId) => {
    setOpenRows((prev) => ({
      ...prev,
      [groupId]: !prev[groupId]
    }));
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Parcelamentos
      </Typography>
      {loading ? (
        <CircularProgress />
      ) : installments.length === 0 ? (
        <Typography>Nenhum parcelamento encontrado.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>Descrição</TableCell>
                <TableCell>Categoria</TableCell>
                <TableCell>Valor Total</TableCell>
                <TableCell>Parcelas</TableCell>
                <TableCell>Data Inicial</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {installments.map((parcelas, idx) => {
                const first = parcelas[0];
                const total = parcelas.reduce((sum, p) => sum + Math.abs(p.value), 0);
                return (
                  <React.Fragment key={first.installment_group_id}>
                    <TableRow>
                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={() => handleToggleRow(first.installment_group_id)}
                        >
                          {openRows[first.installment_group_id] ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )}
                        </IconButton>
                      </TableCell>
                      <TableCell>{first.description}</TableCell>
                      <TableCell>{first.category_id}</TableCell>
                      <TableCell>R$ {total.toFixed(2)}</TableCell>
                      <TableCell>
                        {first.installment_count}x
                      </TableCell>
                      <TableCell>{first.date}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={openRows[first.installment_group_id]} timeout="auto" unmountOnExit>
                          <Box margin={1}>
                            <Typography variant="subtitle1" gutterBottom>
                              Parcelas
                            </Typography>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Parcela</TableCell>
                                  <TableCell>Data</TableCell>
                                  <TableCell>Valor</TableCell>
                                  <TableCell>Status</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {parcelas.map((p) => (
                                  <TableRow key={p.id}>
                                    <TableCell>
                                      {p.installment_number}/{p.installment_count}
                                    </TableCell>
                                    <TableCell>{p.date}</TableCell>
                                    <TableCell>R$ {Math.abs(p.value).toFixed(2)}</TableCell>
                                    <TableCell>
                                      {p.deleted_at ? "Cancelada" : "Pendente"}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}

export default Installments;
